import axios from "axios";


// Register a new user
export const registerUser = async (data: {
  companyName: string;
  username: string;
  password: string;
}) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/user-register`, data);
    return response.data;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};

// Login a user
export const loginUser = async (data: { username: string; password: string }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/user-login`, data);
    return response.data;
  } catch (error) {
    console.error("Error logging in user:", error);
    throw error;
  }
};

// Logout a user
export const logoutUser = async () => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/logout`);
    return response.data;
  } catch (error) {
    console.error("Error logging out user:", error);
    throw error;
  }
};

// Update user details
export const updateUser = async (userId: string, data: { [key: string]: any }) => {
  try {
    const response = await axios.put(`${process.env.REACT_APP_API_URL}/${userId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating user:", error);
    throw error;
  }
};

// Delete a user
export const deleteUser = async (userId: string) => {
  try {
    const response = await axios.delete(`${process.env.REACT_APP_API_URL}/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};